import { rootApi } from "../../api/rootApi";

export const redemtionHistory = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchRedemptionHistory: builder.mutation({
      query: (params) => {
        console.log("zoneId-->", params.zoneId);
        return {
          method: "POST",
          url: `/app/userPointRedemptions/?limit=${params.limit}&offset=${params.offset}&zoneId=${params.zoneId}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    fetchRedemptionHistoryForTDS: builder.mutation({
      query: (params) => {
        console.log("zoneId-->", params.zoneId);
        return {
          method: "POST",
          url: `/app/userPointRedemptions/tds/?limit=${params.limit}&offset=${params.offset}&zoneId=${params.zoneId}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    fetchRedemptionHistoryCountForTDS: builder.mutation({
      query: (params) => {
        console.log("zoneId-->", params.zoneId);
        return {
          method: "POST",
          url: `/app/userPointRedemptions/tds-count/?limit=${params.limit}&offset=${params.offset}&zoneId=${params.zoneId}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    fetchRedemptionHistoryForTDSInProfile: builder.mutation({
      query: (params) => {
        console.log("zoneId-->", params.zoneId);
        return {
          method: "POST",
          url: `/app/userPointRedemptions/profile/${params.userId}?limit=${params.limit}&offset=${params.offset}&zoneId=${params.zoneId}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    deleteRedemption: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/userPointRedemptions/delete`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      }
    })
  }),
});

export const { useFetchRedemptionHistoryMutation , useFetchRedemptionHistoryCountForTDSMutation,useFetchRedemptionHistoryForTDSMutation ,useFetchRedemptionHistoryForTDSInProfileMutation, useDeleteRedemptionMutation} = redemtionHistory;
